import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsStepComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        step: {
            type: Number,
            attribute: 'step',
            reflect: true,
        },
        current: {
            attribute: 'current',
            reflect: true,
        }
    };
    constructor() {
        super();
        this.step;
        this.current;
        this.emailAddressCache = null;
        this.emailAddressCache2 = null;
        this.addEventListener('click', this.handleClick);
        // this.addEventListener('input', this.handleInput);
        this.addEventListener('change', this.handleChange);
    }

    handleChange(event) {
        console.log('handleChange', event);
        if (event.target && event.target.type === 'email') {
            // handle e-mail double field matching. Must be the same, you see.
            console.log('email type field');
            if (this.emailAddressCache !== null) {
                console.log('emailadress cache not null');
                let parentElement = event.target.parentElement;
                if (event.target.value === this.emailAddressCache) {
                    console.log('all good!');
                    if (parentElement) {
                        let invalidFeedback = parentElement.querySelector('.invalid-feedback');
                        if (invalidFeedback) {
                            invalidFeedback.classList.remove('d-block'); // don't force show of invalid-feedback
                        }
                    }
                    
                } else {
                    console.log('email address does not match after filling both');
                    // would trigger feedback
                    // convention: invalid-feedback is an element adjacent to the input: after the input. So go to parent element of input, and query for .invalid-feedback
                    if (parentElement) {
                        let invalidFeedback = parentElement.querySelector('.invalid-feedback');
                        if (invalidFeedback) {
                            invalidFeedback.classList.add('d-block'); // show
                        }
                    }
                }
            } else {
                this.emailAddressCache = event.target.value; // cache the filled in email address
            }
        }
    }
    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: block;  /* or display: block; */
                position: relative;
                margin: 0;
			}
		`;
    }

    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        // console.log('attributeChangedCallback', name, _old, value);
    }

    handleSlotChange(event) {
        console.log('handleSlotChange', event)
        // const childNodes = event.target.assignedNodes({ flatten: true });
        // // ... do something with childNodes ...
        // this.allText = childNodes.map((node) => {
        //     return node.textContent ? node.textContent : ''
        // }).join('');
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });

    }

    /**
     * 
     * @param {PointerEvent} event 
     */
    handleClick(event) {
        event.target.setAttribute('current', "");
        console.log('handleClick', event);
        let paymentBox = event.target.closest('.ticket-payment-box');
        if (paymentBox) {
            console.log('clicked in payment box...', paymentBox);
            let paymentBoxes = this.querySelectorAll('.ticket-payment-box');
            if (paymentBoxes) {
                paymentBoxes.forEach((p) => {
                    p.classList.remove('ticket-payment-box-active');
                });
            }
            // if (paymentBox.classList.contains('ticket-payment-box-active')) {
            paymentBox.classList.add('ticket-payment-box-active');
            let value = paymentBox.value;
            console.log('value', value);
            let paymentSelector = this.querySelector('select[name="payment_method_id"]');
            let idealContainer = this.querySelector(".tickets-ideal-container");
            if (paymentSelector) {
                paymentSelector.value = paymentBox.value;
                console.log('paymentSelector', paymentSelector);
                let iDealPaymentOption = paymentSelector.querySelector(`option[data-payment-option="IDEAL"]`); // comes from payment method type id in CM...
                console.log('iDealPaymentOption', iDealPaymentOption);
                let issuerIdSelector = this.querySelector('select[name="ideal_issuer_id"]');
                if (iDealPaymentOption.value === paymentBox.value) {
                    console.log('ideal!');
                    // iDeal
                    if (issuerIdSelector) {
                        console.log('issuerIdSelector', issuerIdSelector);
                        issuerIdSelector.required = true;
                        idealContainer.classList.remove('d-none');
                        idealContainer.classList.add('d-block');
                    }
                } else {
                    console.log('This is NOT ideal... it is bancontact');
                    if (issuerIdSelector) {
                        issuerIdSelector.required = false;
                        console.log('issuerIdSelector', issuerIdSelector);
                        idealContainer.classList.remove('d-block');
                        idealContainer.classList.add('d-none');
                        issuerIdSelector.value = "";
                    }
                }
            }
            // }
        }
    }

    render() {
        return html`
            <div class="tickets-step" component-loaded>
                <slot @slotchange="${this.handleSlotChange}">...</slot>
                
            </div>
        `;
        // Step debug: ${this.step}
    }
}

window.customElements.define('tickets-step', TicketsStepComponent);